export default __webpack_public_path__ + "static/media/Background 5_00035.7d827d0a.png";